// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__839uc","circular":"Loader_circular__ten-F","rotate":"Loader_rotate__3pElB","path":"Loader_path__1CbsN","dash":"Loader_dash__MAise"};